import { useLayoutEffect, useCallback, useState } from 'react'

/* function used to trigger function when scrolling past element, with option counter function */
export function useOnScreen({
  liveMeasure = true,
  scrollToOffset = 0,
  scrollPastOffset = 0,
}) {
  const [dimensions, setDimensions] = useState(null)
  const [isScrolledPast, setIsScrolledPast] = useState(false)
  const [isScrolledTo, setIsScrolledTo] = useState(false)

  const [node, setNode] = useState(null)

  const ref = useCallback((refNode) => {
    setNode(refNode)
  }, [])

  useLayoutEffect(() => {
    if (node) {
      const measure = () => {
        const rect = node.getBoundingClientRect()
        setIsScrolledPast(rect.bottom < scrollPastOffset)
        setIsScrolledTo(rect.top + scrollToOffset < window.innerHeight)
        window.requestAnimationFrame(() => setDimensions(rect))
      }
      measure()

      if (liveMeasure) {
        window.addEventListener('scroll', measure)
        window.addEventListener('resize', measure)

        return () => {
          window.removeEventListener('scroll', measure)
          window.removeEventListener('resize', measure)
        }
      }
    }
  }, [node, liveMeasure, scrollToOffset, scrollPastOffset])

  return [ref, dimensions, isScrolledPast, isScrolledTo]
}
